/**
 * Converte um array (ou valor escalar legado) em string CSV pro wire de
 * query params. Pula entradas `null`, `undefined` e string vazia
 * defensivamente; retorna `''` (falsy) quando nada sobra — assim o caller
 * pode omitir o param em vez de mandar `?key=`.
 *
 * @param {Array|*} value - array multi-select ou valor único legado
 * @returns {string} CSV pronto pro wire, ou '' quando vazio
 */
export const toCsv = (value) => {
  if (value == null) return ''
  const list = Array.isArray(value) ? value : [value]
  const filtered = list.filter((v) => v !== null && v !== undefined && v !== '')
  if (filtered.length === 0) return ''
  return filtered.join(',')
}
